import { useRecoilValue } from 'recoil';

import stateFilterSex from "../../state/stateFilterSex";
import stateFilterDisease from "../../state/stateFilterDisease";
import stateFilterPhenotype from "../../state/stateFilterPhenotype";
import stateFilterVariant from '../../state/stateFilterVariant';
import stateFilterRange from '../../state/stateFilterRange';
import BeaconFilterItem from '../../models/BeaconFilterItem';
import BeaconFilter from '../../models/BeaconFilter';
import { useMemo } from 'react';
import stateFilterGene from '../../state/stateFilterGene';


function useQuery() {
    const filterSex = useRecoilValue(stateFilterSex);
    const filterDisease = useRecoilValue(stateFilterDisease);
    const filterPhenotype = useRecoilValue(stateFilterPhenotype);
    const filterVariant = useRecoilValue(stateFilterVariant);
    const filterRange = useRecoilValue(stateFilterRange);
    const filterGene = useRecoilValue(stateFilterGene);
    const filter = useMemo(() => ({
        filters: ([filterSex, filterDisease, filterPhenotype].filter((elem) => !!elem) as BeaconFilterItem[]),
        variant: filterVariant,
        range: filterRange,
        gene: filterGene
    } as BeaconFilter), [filterSex, filterDisease, filterPhenotype, filterVariant, filterRange, filterGene]);
    return filter;
}


export default useQuery;
